import { openapi } from "../../openapi";
import { thunkToast } from "../DesignTab/designSlice";
import { patchRoomFromQueryFulfilled, patchRoomsFromQueryFulfilled } from "../McBim/McBimSlice";

const withGenericErrorToast =
  (inner?: (arg: any, helpers: { dispatch: any; queryFulfilled: Promise<any> }) => Promise<void>) =>
  async (arg: any, helpers: { dispatch: any; queryFulfilled: Promise<any> }) => {
    const { dispatch, queryFulfilled } = helpers;
    try {
      if (inner) {
        await inner(arg, helpers);
      } else {
        await queryFulfilled;
      }
    } catch {
      showGenericSaveErrorToast(dispatch);
    }
  };

const showGenericSaveErrorToast = (dispatch: any) => {
  dispatch(
    thunkToast({
      text: "Kunne ikke lagre data",
      header: "Misslykket",
      isSuccess: false,
    })
  );
};

export const roomEnhancer = openapi.enhanceEndpoints({
  endpoints: {
    postMultiplacerRoomValidationDecisionStatus: {
      async onQueryStarted(args, { dispatch, queryFulfilled, getState }) {
        await patchRoomFromQueryFulfilled({ dispatch, getState, queryFulfilled });
      },
      invalidatesTags: ["SingleRoom"],
    },
    postMultiplacerRooms: {
      providesTags: ["Rooms"],
    },
    postMultiplacerRoomsUpdateCalculatedRoomNumbers: {
      invalidatesTags: ["Rooms"],
    },
    putMultiplacerRoomsRoomNumberingManualValue: {
      async onQueryStarted(args, { dispatch, queryFulfilled, getState }) {
        await patchRoomFromQueryFulfilled({ dispatch, getState, queryFulfilled });
      },
    },
    deleteMultiplacerRoomsRoomNumberingManualValue: {
      async onQueryStarted(args, { dispatch, queryFulfilled, getState }) {
        await patchRoomFromQueryFulfilled({ dispatch, getState, queryFulfilled });
      },
    },
    postMultiplacerRoomsRoomNumberingApproval: {
      async onQueryStarted(args, { dispatch, queryFulfilled, getState }) {
        await patchRoomFromQueryFulfilled({ dispatch, getState, queryFulfilled });
      },
    },
    deleteMultiplacerRoomsRoomNumberingApproval: {
      async onQueryStarted(args, { dispatch, queryFulfilled, getState }) {
        await patchRoomFromQueryFulfilled({ dispatch, getState, queryFulfilled });
      },
    },
    postMultiplacerRoomsRoomNumberingApprovalBulk: {
      async onQueryStarted(args, { dispatch, queryFulfilled, getState }) {
        await patchRoomsFromQueryFulfilled({ dispatch, getState, queryFulfilled });
      },
    },
    postMultiplacerRoomsRoomNumberingApprovalBulkClear: {
      async onQueryStarted(args, { dispatch, queryFulfilled, getState }) {
        await patchRoomsFromQueryFulfilled({ dispatch, getState, queryFulfilled });
      },
    },
    deleteMultiplacerRoomValidation: {
      invalidatesTags: ["Rooms"],
    },
    getMultiplacerSingleRoom: {
      providesTags: ["SingleRoom"],
    },
    postMultiplacerRoomValidationDecisionComment: {
      onQueryStarted: withGenericErrorToast(),
      invalidatesTags: ["SingleRoom"],
    },
    postMultiplacerRoomValidationDecisionCommentUpdate: {
      onQueryStarted: withGenericErrorToast(),
      invalidatesTags: ["SingleRoom"],
    },
    postMultiplacerRoomValidationDecisionCommentDelete: {
      onQueryStarted: withGenericErrorToast(),
      invalidatesTags: ["SingleRoom"],
    },
    postMultiplacerRoomCeilingComment: {
      onQueryStarted: withGenericErrorToast(),
      invalidatesTags: ["SingleRoom", "Rooms"],
    },
    postMultiplacerRoomCeilingCommentUpdate: {
      onQueryStarted: withGenericErrorToast(),
      invalidatesTags: ["SingleRoom", "Rooms"],
    },
    postMultiplacerRoomCeilingCommentDelete: {
      onQueryStarted: withGenericErrorToast(),
      invalidatesTags: ["SingleRoom", "Rooms"],
    },
  },
});
